export default __webpack_public_path__ + "static/media/spaghetti-code.a4d97254.png";